<template>
  <div class="text-[#1E293B] min-h-screen p-6 sm:p-10 font-inter bg-[#F8FAFC]">
    <main class="max-w-2xl mx-auto">
      <h1 class="text-2xl font-semibold mb-1">Mon Compte</h1>
      <p class="text-sm text-[#475569] mb-6">Modifier vos informations personnelles</p>

      <form @submit.prevent="submitForm" class="space-y-5 bg-white p-6 rounded-lg border border-[#E2E8F0] shadow-sm">
        <!-- Prénom -->
        <div>
          <label class="block text-sm font-medium text-[#334155] mb-1">Prénom</label>
          <input v-model="form.prenom" type="text" class="w-full border border-[#E2E8F0] rounded-md px-3 py-2 text-sm" required />
        </div>

        <!-- Nom -->
        <div>
          <label class="block text-sm font-medium text-[#334155] mb-1">Nom</label>
          <input v-model="form.nom" type="text" class="w-full border border-[#E2E8F0] rounded-md px-3 py-2 text-sm" required />
        </div>

        <!-- Email -->
        <div>
          <label class="block text-sm font-medium text-[#334155] mb-1">Email</label>
          <input v-model="form.email" type="email" class="w-full border border-[#E2E8F0] rounded-md px-3 py-2 text-sm" required />
        </div>

        <!-- Téléphone -->
        <div>
          <label class="block text-sm font-medium text-[#334155] mb-1">Téléphone</label>
          <input v-model="form.telephone" type="text" class="w-full border border-[#E2E8F0] rounded-md px-3 py-2 text-sm" required />
        </div>

        <!-- Date de naissance -->
        <div>
          <label class="block text-sm font-medium text-[#334155] mb-1">Date de naissance</label>
          <input v-model="form.date_naissance" type="date" class="w-full border border-[#E2E8F0] rounded-md px-3 py-2 text-sm" required />
        </div>

        <!-- Genre -->
        <div>
          <label class="block text-sm font-medium text-[#334155] mb-1">Genre</label>
          <select v-model="form.genre" class="w-full border border-[#E2E8F0] rounded-md px-3 py-2 text-sm" required>
            <option value="">Sélectionner</option>
            <option value="Homme">Homme</option>
            <option value="Femme">Femme</option>
          </select>
        </div>

        <!-- Nouveau mot de passe -->
        <div>
          <label class="block text-sm font-medium text-[#334155] mb-1">Nouveau mot de passe</label>
          <input
            v-model="form.password"
            type="password"
            placeholder="Laisser vide pour ne pas changer"
            class="w-full border border-[#E2E8F0] rounded-md px-3 py-2 text-sm"
          />
        </div>

        <!-- Bouton de soumission -->
        <div class="flex justify-end">
          <button
            type="submit"
            class="bg-[#0F172A] text-white px-5 py-2 rounded-md text-sm hover:bg-[#1E293B] transition"
          >
            Enregistrer les modifications
          </button>
        </div>
      </form>

      <!-- Messages -->
      <div v-if="successMessage" class="mt-4 text-sm text-green-600 border border-green-200 bg-green-50 rounded p-3">
        {{ successMessage }}
      </div>
      <div v-if="errorMessage" class="mt-4 text-sm text-red-600 border border-red-200 bg-red-50 rounded p-3">
        {{ errorMessage }}
      </div>
    </main>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const form = ref({
  prenom: '',
  nom: '',
  email: '',
  telephone: '',
  date_naissance: '',
  genre: '',
  password: '',
})

const successMessage = ref('')
const errorMessage = ref('')

const token = localStorage.getItem('clientToken')

// Charger les infos du client
onMounted(async () => {
  if (!token) {
    errorMessage.value = 'Utilisateur non authentifié.'
    return
  }

  try {
    const res = await fetch('https://b53c7d5edf32.ngrok-free.app/api/clients/profile', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    if (!res.ok) throw new Error('Erreur lors du chargement des données.')

    const data = await res.json()
    form.value = {
      prenom: data.prenom || '',
      nom: data.nom || '',
      email: data.email || '',
      telephone: data.telephone || '',
      date_naissance: data.date_naissance?.slice(0, 10) || '',
      genre: data.genre || '',
      password: '',
    }
  } catch (err) {
    errorMessage.value = err.message
  }
})

// Mettre à jour les infos
async function submitForm() {
  if (!token) {
    errorMessage.value = 'Utilisateur non authentifié.'
    return
  }

  try {
    const payload = {
      prenom: form.value.prenom,
      nom: form.value.nom,
      email: form.value.email,
      telephone: form.value.telephone,
      date_naissance: form.value.date_naissance,
      genre: form.value.genre,
      ...(form.value.password ? { password: form.value.password } : {}),
    }

    const res = await fetch('https://b53c7d5edf32.ngrok-free.app/api/clients/profile', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    })

    if (!res.ok) throw new Error('Erreur lors de la mise à jour.')

    successMessage.value = 'Vos informations ont bien été mises à jour.'
    errorMessage.value = ''
    form.value.password = ''

    setTimeout(() => (successMessage.value = ''), 4000)
  } catch (err) {
    successMessage.value = ''
    errorMessage.value = err.message
  }
}
</script>
